import { FormikValues } from "formik";

import { FormikTextFieldProps } from "../FormikTextField.types";
import { FormikDigitsField } from "../formik-digits-field/FormikDigitsField";

export function FormikZipCodeField<T extends FormikValues>(props: FormikTextFieldProps<T>) {
  return <FormikDigitsField {...props} />;
}
